import type { CategoryDto } from '@trestly/shared';
import { Chip, ChipRail } from './Chip';
import { lookOf, NO_CATEGORY } from '../lib/envelope';
import { t } from '../i18n';

interface CategoryChipsProps {
  categories: CategoryDto[];
  value: number | null;
  onChange: (categoryId: number | null) => void;
  /** Чип «Без категории» — трата может быть вне бюджета. */
  allowEmpty?: boolean;
  /** Одной лентой с прокруткой, а не переносом: в листе с клавиатурой. */
  rail?: boolean;
}

/** Цвет конверта — тот же, что у плитки на главной: категорию узнают по нему. */
function Dot({ color }: { color: string }): JSX.Element {
  return <span className="cat-dot" style={{ '--c': color } as React.CSSProperties} aria-hidden />;
}

/** Выбор категории таблетками. Архивные не показываем: их не выбирают заново. */
export function CategoryChips({
  categories,
  value,
  onChange,
  allowEmpty = true,
  rail = false,
}: CategoryChipsProps): JSX.Element {
  const visible = categories.filter((category) => !category.archived);

  const chips = (
    <>
      {visible.map((category) => (
        <Chip key={category.id} active={value === category.id} onClick={() => onChange(category.id)}>
          <Dot color={lookOf(category).color} />
          {category.name}
        </Chip>
      ))}
      {allowEmpty ? (
        <Chip active={value === null} onClick={() => onChange(null)}>
          <Dot color={NO_CATEGORY.color} />
          {NO_CATEGORY.name}
        </Chip>
      ) : null}
    </>
  );

  if (rail) return <ChipRail label={t('components.category')}>{chips}</ChipRail>;

  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label={t('components.category')}>
      {chips}
    </div>
  );
}
